import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML string before it is injected via dangerouslySetInnerHTML.
 *
 * Markdown rendered by `marked` can contain arbitrary HTML/script when the
 * source is attacker-influenced — audit `.md` reports come from client-uploaded
 * ZIPs. Running the result through
 * DOMPurify strips scripts, event handlers, and dangerous URIs while keeping the
 * formatting we render.
 *
 * `data-internal-link` (used by the Help page's custom link renderer) is kept so
 * the SPA's internal-navigation handler still works after sanitization.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'data-internal-link'],
  });
}
